import PropTypes from 'prop-types';
import DebugLogger from "../../../helpers/DebugLogger";

import { HexColorPicker } from "react-colorful";

import "./ColorPicker.scss";
import FormField from '../FormField/FormField';
import { useContext, useEffect, useRef, useState } from 'react';
import { ShowColorPicker } from './ColorPickerPopUp';
import { COLOUR_HEX_TO_COLOUR_NAME, COLOUR_NAME_TO_COLOUR_HEX, IS_COLOUR_NAME } from '../../../helpers/Colours';
import { CampaignContext } from '../../../contexts/CampaignContext';

const ColorPicker = (props) => {
    const [campaignContext, setCampaignContext] = useContext(CampaignContext);

    const firstValChange = useRef(true);
    const { showLabel, inlineLabel, label, labelNote, id, setFunc, value, className } = props;

    if (showLabel && label === 'Field Label') {
        DebugLogger.warn('No label provided to FormField, using default...');
    }

    const [currentVal, setCurrentVal] = useState('#000000');
    const setVal = (newVal, confirm = false) => {
        const colourVal = COLOUR_NAME_TO_COLOUR_HEX(newVal, campaignContext.campaignData);
        // console.log('Confirm colour val: ', newVal, colourVal);
        const newValIsAColour = (newVal?.toUpperCase() ?? newVal) === colourVal || (newVal?.toUpperCase() ?? newVal) === colourVal.substring(1);
        if (newValIsAColour) {
            if (newVal.substring(0, 1) !== '#') {
                newVal = '#' + newVal;
            }
            // console.log('Val is a colour: ', newVal);
            if (/^#[0-9A-F]{6}$/i.test(newVal)) {
                // console.log('Val is a hex colour: ', newVal);
                setCurrentVal(newVal);
                if (!firstValChange.current || props.immediateChange || confirm) {
                    if (setFunc) {
                        setFunc(newVal);
                    }
                }
                firstValChange.current = false;
            } else {
                setCurrentVal(value);
            }
        } else {
            // console.log('Val is not a colour: ', newVal);
            // We are dealing with a colour name, so we need to set the value to newVal (GET_COLOUR confirms this is valid)
            // When confirming (ie. field loses focus, so we stopped typing), we want to replace alternatives that we accept with the proper colour name
            setCurrentVal(confirm ? COLOUR_HEX_TO_COLOUR_NAME(colourVal, campaignContext.campaignData) : newVal);
            if (!firstValChange.current || props.immediateChange || confirm) {
                if (setFunc) {
                    setFunc(confirm ? COLOUR_HEX_TO_COLOUR_NAME(colourVal, campaignContext.campaignData) : newVal);
                }
            }
        }
    }
    useEffect(
        () => {
            // console.log('[useEffect] Setting colour val: ', id, value);
            setVal(value ?? '#000000');
        }
        , [value]
    );

    const showColorPickerPopUp = () => {
        props.hideTooltipFunc();
        ShowColorPicker(currentVal, setVal, campaignContext.campaignData, null, props.showTooltipFunc, props.hideTooltipFunc);
    }

    return (
        <div className={`form-field-holder${className ? ` ${className}` : ''}`}>

            <div className="form-field-content-holder">

                {showLabel && !inlineLabel && label != null &&
                    <div className="form-field-content label">
                        {label}
                    </div>
                }
                {showLabel && !inlineLabel && labelNote != null && labelNote !== '' &&
                    <div className="form-field-content label-note" dangerouslySetInnerHTML={{__html: labelNote}}>
                        {/*labelNote*/}
                    </div>
                }

                <div className="form-field-content">
                    {showLabel && inlineLabel && label != null &&
                        <div className="label">
                            {label}
                        </div>
                    }

                    <div className="current-color" 
                        style={{ background: COLOUR_NAME_TO_COLOUR_HEX(currentVal, campaignContext.campaignData) }} 
                        onClick={showColorPickerPopUp}
                        onMouseEnter={props.showTooltipFunc && IS_COLOUR_NAME(currentVal) ? (e) => props.showTooltipFunc(COLOUR_NAME_TO_COLOUR_HEX(currentVal, campaignContext.campaignData), e) : null}
                        onMouseLeave={props.hideTooltipFunc}
                        onMouseDown={props.hideTooltipFunc}
                    ></div>

                    <FormField
                        id={id || "colourPicker"}
                        placeholder="#000000"
                        showLabel={false}
                        type="text"
                        maxLength={12}
                        setFunc={setVal}
                        confirmChangeFunc={(val) => setVal(val, true)}
                        value={currentVal}
                        showError={false}
                        className="c-hex-field"
                    />

                    <div className='grow'></div>
                </div>

            </div>

        </div>
    );
};

ColorPicker.propTypes = {
    showLabel: PropTypes.bool,
    inlineLabel: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
    labelNote: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    id: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    setFunc: PropTypes.func,
    confirmChangeFunc: PropTypes.func,
    immediateChange: PropTypes.bool,
};

ColorPicker.defaultProps = {
    showLabel: true,
    inlineLabel: false,
    label: 'Field Label',
    labelNote: '',
    id: '',
    value: '#000000',
    className: '',
    setFunc: null,
    confirmChangeFunc: null,
    immediateChange: false,
}

export default ColorPicker;
